/**
 * Lottery Mobile Preview – full app screen mockup so the dashboard preview
 * looks exactly like the lottery card inside the real app (phone frame + header + card).
 */

export interface LotteryMobilePreviewProps {
  title: string;
  description: string;
  imageUrl: string | null;
  locale?: "en" | "nl";
  /** Show green "Joined" badge on the card (optional, for realism) */
  showJoinedBadge?: boolean;
}

function resolveImageSrc(url: string | null): string | null {
  if (!url) return null;
  if (
    url.startsWith("http://") ||
    url.startsWith("https://") ||
    url.startsWith("blob:")
  ) {
    return url;
  }
  const base = process.env.REACT_APP_BASE_URL ?? "";
  const path = url.startsWith("/") ? url : `/${url}`;
  return base ? `${base.replace(/\/$/, "")}${path}` : url;
}

export function LotteryMobilePreview({
  title,
  description,
  imageUrl,
  locale = "en",
  showJoinedBadge = false,
}: LotteryMobilePreviewProps) {
  const resolvedImage = resolveImageSrc(imageUrl);

  return (
    <div
      className="overflow-hidden aspect-[430/928] w-full rounded-[3.5rem] border-[10px] border-gray-800 shadow-3xl flex items-center p-3 justify-center"
      style={{
        flexShrink: 0,
        backgroundColor: "#FAEBE1",
      }}
    >
      {/* card */}
      <div className="bg-white overflow-hidden flex flex-col aspect-[383/274] w-full rounded-xl relative">
        {/* join button */}
        <div className="absolute text-xs py-[2px] font-satoshi font-medium text-white z-1 top-2 left-2 rounded-xl px-2 bg-[#23C16B]">
          Joined
        </div>

        {/* image  */}
        <div className="h-[75px] shrink-0 w-full  overflow-hidden">
          <img
            src={resolvedImage ?? ""}
            alt=""
            className="w-full h-full object-cover"
          />
        </div>

        <div className="p-3">
          <div className="text-sm font- font-bold text-inkDark">{title}</div>
          <div className="text-xs font-satoshi font-normal text-inkLight">
            {description}
          </div>
        </div>
      </div>
    </div>
  );
}
